import * as firebase from 'firebase';

export const FETCH_MEMBERS = 'fetch_members';
export const FETCH_MEMBERS_SUCCESS = 'fetch_member_success';

export const DELETE_MEMBER = 'delete_member';
export const DELETE_MEMBER_SUCCESS = 'delete_member_success';
export const DELETE_MEMBER_FAIL = 'delete_member_fail';

export function fetchAllMembers() {

    const membersRef = firebase.database().ref('members');

    return dispatch => {
        dispatch({ type: FETCH_MEMBERS });

        membersRef.on('value', snapshot => {

            const value = snapshot.val();

            if (value) {
                dispatch({
                    type: FETCH_MEMBERS_SUCCESS,
                    payload: value
                });
            }

            // if (snapshot.val()) {
            //     let rawMembers = [];
            //     snapshot.forEach(rawMember => {
            //         const uid = rawMember.key;
            //         const member = rawMember.val();

            //         rawMembers.push({ ...member, uid: uid });
            //     });

            //     dispatch({
            //         type: FETCH_MEMBERS_SUCCESS,
            //         payload: rawMembers
            //     });
            // }
        });
    };
}

export function fetchMember(uid, callback) {

    const memberRef = firebase.database().ref('members').child(uid);

    return dispatch => {
        memberRef.once('value')
            .then(snapshot => {
                const memberData = snapshot.val();
                if (callback) {
                    callback(memberData);
                }
            })
            .catch(error => {
                if (callback) {
                    callback(null, error.message);
                }
            });
    };
}

export function deleteMember(uid) {
    // omit member from members

    const memberRef = firebase.database().ref('members').child(uid);

    return dispatch => {

        dispatch({ type: DELETE_MEMBER });

        memberRef.remove()
            .then(() => {
                // success
                dispatch({
                    type: DELETE_MEMBER_SUCCESS,
                    payload: uid
                });
            })
            .catch(error => {
                dispatch({ 
                    type: DELETE_MEMBER_FAIL,
                    payload: error.message
                });
            });
    };
}


// WEBPACK FOOTER //
// ./src/actions/Member.js